import React from "react";
import cx from "classnames";
import styles from "./Statistics.module.scss";
import Image from "@components/Image";
import Item from "./Item";
import { usePageContext } from "@providers/PageProvider";
import { sustainabilityPage } from "@utils/helper";
import _ from "lodash";

export default function Statistics() {
  const { pageData } = usePageContext();
  const dataSection = sustainabilityPage.formatDataSection(pageData);
  return (
    <div
      data-scroll-section
      className={cx("flex flex-col mx-auto items-center", styles.section)}
    >
      <div className={cx(styles.title)}>{_.get(dataSection, "title")}</div>
      <div className="w-full overflow-auto">
        <div className={cx("flex", styles.iconImageWrapper)}>
          {_.map(_.get(dataSection, "icons"), (icon, index) => {
            return (
              <Image
                speed={0}
                {...icon}
                alt={icon?.alt || `Statistics icon ${index + 1}`}
                wrapperProps={{ className: cx(styles.iconImage) }}
                key={index}
                layout="fill"
                objectFit="contain"
              />
            );
          })}
        </div>
      </div>
      <div className={cx("flex w-full", styles.statisticsItemWrapper)}>
        {_.map(_.get(dataSection, "infos"), (item, index) => {
          return (
            <Item
              key={`item_${index}`}
              {...{
                number: item.data,
                title: item.unit,
                content: item.source,
              }}
            />
          );
        })}
      </div>
    </div>
  );
}
